import styled from 'styled-components/macro'

const FormContainer = styled.div`
	max-width: 700px;
	margin: auto;
`
export default FormContainer
